<h2 mat-dialog-title>
  Forgot your password?
</h2>
<mat-dialog-content>
  <p>
    We sent an email to {{email}} with instructions on how to reset <br>
    your password.<br><br>
    If you can't find the email in your inbox, check your spam folder. The email<br>
    should come from: {{noReplyEmail}}
  </p>
</mat-dialog-content>
<mat-dialog-actions class="flex row end-center">
  <button mat-button [mat-dialog-close]="true" color="primary">OK</button>
</mat-dialog-actions>
